// src/pages/Appli/AppliAdmin/clubs-admin/data/clubsAdmin.data.js

export const CLUBS_PAGE_SIZE = 20;

export const CLUB_LOGO_FALLBACK = "/img/no-image.jpg";